var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/money-recive"
  }, /*#__PURE__*/React.createElement("g", {
    id: "money-recive"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.70064 10.8333H7.44733C6.56066 10.8333 5.83398 10.0867 5.83398 9.16666C5.83398 8.89332 6.06065 8.66666 6.33398 8.66666C6.60732 8.66666 6.83398 8.89332 6.83398 9.16666C6.83398 9.53332 7.10733 9.83332 7.44733 9.83332H8.70064C8.96064 9.83332 9.16732 9.59999 9.16732 9.31332C9.16732 8.95332 9.06732 8.89999 8.84066 8.81999L6.83398 8.11998C6.40732 7.97332 5.83398 7.65999 5.83398 6.67999C5.83398 5.84666 6.49399 5.15999 7.30066 5.15999H8.55398C9.44064 5.15999 10.1673 5.90666 10.1673 6.82666C10.1673 7.09999 9.94065 7.32666 9.66732 7.32666C9.39398 7.32666 9.16732 7.09999 9.16732 6.82666C9.16732 6.45999 8.89398 6.15999 8.55398 6.15999H7.30066C7.04066 6.15999 6.83398 6.39332 6.83398 6.67999C6.83398 7.03999 6.93398 7.09332 7.16064 7.17332L9.16732 7.87332C9.59398 8.01999 10.1673 8.33332 10.1673 9.31332C10.1673 10.1533 9.50731 10.8333 8.70064 10.8333Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8 11.5C7.72667 11.5 7.5 11.2733 7.5 11V5C7.5 4.72667 7.72667 4.5 8 4.5C8.27333 4.5 8.5 4.72667 8.5 5V11C8.5 11.2733 8.27333 11.5 8 11.5Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.00065 15.1667C4.04732 15.1667 0.833984 11.9533 0.833984 8C0.833984 4.04667 4.04732 0.833332 8.00065 0.833332C8.27398 0.833332 8.50065 1.06 8.50065 1.33333C8.50065 1.60667 8.27398 1.83333 8.00065 1.83333C4.60065 1.83333 1.83398 4.6 1.83398 8C1.83398 11.4 4.60065 14.1667 8.00065 14.1667C11.4007 14.1667 14.1673 11.4 14.1673 8C14.1673 7.72667 14.394 7.5 14.6673 7.5C14.9407 7.5 15.1673 7.72667 15.1673 8C15.1673 11.9533 11.954 15.1667 8.00065 15.1667Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.0007 5.16667H11.334C11.0607 5.16667 10.834 4.94 10.834 4.66667V2C10.834 1.72667 11.0607 1.5 11.334 1.5C11.6073 1.5 11.834 1.72667 11.834 2V4.16667H14.0007C14.274 4.16667 14.5007 4.39333 14.5007 4.66667C14.5007 4.94 14.274 5.16667 14.0007 5.16667Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.3343 5.16667C11.2076 5.16667 11.0809 5.12 10.9809 5.02C10.7876 4.82667 10.7876 4.50667 10.9809 4.31334L14.3143 0.980003C14.5076 0.78667 14.8276 0.78667 15.0209 0.980003C15.2143 1.17334 15.2143 1.49333 15.0209 1.68667L11.6876 5.02C11.5876 5.12 11.4609 5.16667 11.3343 5.16667Z",
    fill: "#878787"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction);
export default __webpack_public_path__ + "static/media/transaction.f0f763c902f46439c05ac58758642443.svg";
export { ForwardRef as ReactComponent };